module.exports = __webpack_public_path__ + "static/img/blood_pressure.d8141bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/specialities/blood_pressure.png
// module id = KYwm
// module chunks = 7